{
  "name": "merlin-cloud",
  "version": "19.1.0",
  "scripts": {
    "ci": "npm i",
    "start:d2": "ng serve -o --port 4200 -c d2",
    "node20_build": "set NODE_OPTIONS=--openssl-legacy-provider --max-old-space-size=8192 &&  ng build --configuration production --aot --output-hashing=all --base-href  /merlin-cloud/",
    "node20_start:d3": "set NODE_OPTIONS=--openssl-legacy-provider --max-old-space-size=8192&& ng serve -c d3",
    "node20_start:d4": "set NODE_OPTIONS=--openssl-legacy-provider --max-old-space-size=8192 && ng serve -o --port 4200 -c d4",
    "start:d3": "ng serve -o --port 4200 -c d3",
    "start:d4": "ng serve -o --port 4200 -c d4",
    "start:t4": "ng serve -o --port 4200 -c t4",
    "start:t3": "ng serve -o --port 4200 -c t3",
    "build": "set NODE_OPTIONS=--openssl-legacy-provider --max-old-space-size=8192 && ng build --configuration production --base-href  /merlin-cloud/",
    "build-dev": " ng build --base-href  /merlin-cloud/",
    "post-build": "cp -r /app/dist/merlin-cloud/* /app/dist/",
    "test": "ng test --watch --code-coverage",
    "e2e": "ng e2e",
    "init-project:d2": "npm install && npm run start:d2",
    "init-project:d3": "npm install && npm run start:d3",
    "init-project:d4": "npm install && npm run start:d4",
    "start": "ng serve -o --port 4200",
    "build-project:prod": "ng build --prod",
    "build-project:prod:vdi": "npm install && ng build --configuration production --aot --output-hashing=all --base-href /merlin-cloud/",
    "test:clinician": "ng test --project clinician --watch --code-coverage",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "lint:export": "ng lint > staticCodeAnalysis.txt",
    "prettier:check": "prettier --check \"./**/*.{html,scss,json}\"",
    "prettier:write": "prettier --write \"./**/*.{html,scss,json}\"",
    "husky": {
      "hooks": {
        "pre-commit": "lint-staged"
      }
    },
    "lint-staged": {
      "*.(|html|scss)": [
        "prettier --write \"./**/*.{html,scss}\"",
        "git add"
      ],
      ".js": [
        "npm run lint:fix",
        "npm run lint"
      ]
    }
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.15",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.15",
    "@angular/compiler": "^19.2.15",
    "@angular/core": "^19.2.15",
    "@angular/forms": "^19.2.15",
    "@angular/material": "^19.2.19",
    "@angular/material-moment-adapter": "^19.2.19",
    "@angular/platform-browser": "^19.2.15",
    "@angular/platform-browser-dynamic": "^19.2.15",
    "@angular/router": "^19.2.15",
    "@azure/msal-angular": "^3.1.0",
    "@azure/msal-browser": "^3.28.1",
    "@fortawesome/fontawesome-free": "^6.2.1",
    "@highcharts/map-collection": "^2.3.0",
    "@ng-idle/core": "^12.0.4",
    "@ng-idle/keepalive": "^12.0.4",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^16.0.1",
    "angular-oauth2-oidc": "^15.0.1",
    "dayjs": "^1.11.7",
    "dropzone": "^6.0.0-beta.2",
    "file-saver": "^2.0.5",
    "flexboxgrid": "^6.3.1",
    "highcharts-angular": "^4.0.1",
    "html-to-image": "^1.11.13",
    "html2canvas": "^1.4.1",
    "html2pdf.js": "^0.10.1",
    "husky": "^6.0.0",
    "jquery": "^3.6.1",
    "jszip": "^3.10.1",
    "jwt-decode": "^3.1.2",
    "lint-staged": "^12.5.0",
    "lodash-es": "^4.17.21",
    "merlin-library": "file:merlin-library-19.2.10.tgz",
    "moment": "^2.29.4",
    "moment-timezone": "^0.5.39",
    "ng2-pdf-viewer": "^7.0.2",
    "ng2-pdfjs-viewer": "^19.0.0",
    "ngx-mat-select-search": "^7.0.10",
    "ngx-toastr": "^19.0.0",
    "prettier": "^3.5.3",
    "rxjs": "^7.8.2",
    "rxjs-compat": "^6.6.7",
    "tslib": "^2.0.0",
    "uuid": "^9.0.1",
    "xlsx": "^0.17.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.15",
    "@angular/cli": "^19.2.15",
    "@angular/compiler-cli": "^19.2.15",
    "@biesbjerg/ngx-translate-extract": "^7.0.4",
    "@compodoc/compodoc": "^1.2.1",
    "@stryker-mutator/core": "^9.6.1",
    "@stryker-mutator/karma-runner": "^9.6.1",
    "@stryker-mutator/typescript-checker": "^9.6.1",
    "@types/jasmine": "~3.5.0",
    "@types/jasminewd2": "^2.0.10",
    "@types/jquery": "^3.5.14",
    "@types/node": "^12.20.55",
    "highcharts": "^9.3.3",
    "highcharts-custom-events": "^3.0.10",
    "jasmine-core": "~4.6.1",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.1",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "ng-packagr": "19.2.2",
    "protractor": "~7.0.0",
    "ts-node": "~8.3.0",
    "tslint": "~6.1.0",
    "typescript": "~5.5.2",
    "webpack-bundle-analyzer": "^4.10.2"
  }
}
